(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Bail on touch/mobile devices — parallax is jarring on scroll-momentum screens
    const isTouchDevice = () =>
      window.matchMedia('(hover: none) and (pointer: coarse)').matches;

    // Bail if user prefers reduced motion
    const prefersReducedMotion = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initParallax() {
      if (isTouchDevice() || prefersReducedMotion()) return;

      const sections = document.querySelectorAll('.hero--parallax');
      if (!sections.length) return;

      const PARALLAX_STRENGTH = 0.1; // 0 = no movement, 1 = full scroll speed. 0.3 is subtle.

      let ticking = false;

      function updateParallax() {
        sections.forEach((section) => {
          const rect = section.getBoundingClientRect();
          const viewH = window.innerHeight;

          // Only animate when the section is in/near the viewport
          if (rect.bottom < 0 || rect.top > viewH) return;

          // How far through the viewport is the section centre?
          const sectionCentre = rect.top + rect.height / 2;
          const offset = (sectionCentre - viewH / 2.5) * PARALLAX_STRENGTH;

          const mediaEls = section.querySelectorAll('.hero__media-parallax');
          mediaEls.forEach((el) => {
            el.style.transform = `translateY(${offset}px)`;
          });
        });

        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });

      // Run once on load to set initial position
      updateParallax();
    }

    // Wait for DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initParallax);
    } else {
      initParallax();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
